/**
* 头部菜单
*/ 
<template>
  <div>
    <el-menu
    class="el-menu-demo"
    mode="horizontal"
    background-color="#fff"
    text-color="#000"
    active-text-color="#fff"
  >
    <el-button class="buttonimg">
      <img
        class="showimg"
        :src="collapsed ? imgsq : imgshow"
        @click="toggle1(collapsed)"
      />
    </el-button>

    <!-- 在需要返回的页面显示返回按鈕 -->
    <el-button
      v-if="showBack"
      icon="el-icon-arrow-left"
      size="small"
      plain
      style="float: left; margin: 13px 0 0 20px"
      @click="handleBack"
    >返回</el-button>

    <el-dropdown style="float:right;margin:15px 10px 0px"  @command="handleCommand">
      <span class="el-dropdown-link" style="position: relative;top: 1px">
        {{name}}<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <!-- <el-dropdown-item  v-if="operatorShow==false" command="1"> 设置</el-dropdown-item> -->
        <el-dropdown-item  v-if="operatorShow==false" command="2" @click="changePwd()">修改密码</el-dropdown-item>
        <el-dropdown-item  v-if="operatorShow==false" command="4" @click="changePhone()">修改手机号</el-dropdown-item>
        <el-dropdown-item  command="3" @click="exit()" >退出</el-dropdown-item>
     
      </el-dropdown-menu>
    </el-dropdown>
   
    <!-- <span style="float: right; font-size: 14px; line-height: 50px" @click="bigScreen" v-if="operatorShow==false"
      >大屏统计</span
    > -->

  </el-menu>
  <el-dialog
      :title="'更改密码'"
      :visible.sync="editFormVisible02"
      width="50%"
      @click="closeDialog02()"
    >
      <el-form label-width="120px" ref="addFormInline" :model="addFormInline">
        <el-form-item label="*旧密码：">
          <el-input
            size="small"
            type="password"
            v-model="addFormInline.oldPassword"
            auto-complete="off"
            placeholder="请输入用户旧密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="*新密码：">
          <el-input
            size="small"
            type="password"
            v-model="addFormInline.newPassword"
            auto-complete="off"
            placeholder="请输入用户新密码"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editFormVisible02=false">取消</el-button>
        <el-button
          size="small"
          type="primary"

          class="title"
          @click="editPassword()"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { loginout,editPasswordCD } from "../api/userMG";
export default {
  name: "navcon",
  data() {
    return {
      addFormInline:{
        oldPassword:'',
        newPassword:''
      },
      phoneForm: {
        phone: '',
        code: ''
      },
      editFormVisible02:false,
      phoneDialogVisible: false,
      collapsed: true,
      imgshow: require("../assets/img/show.png"),
      imgsq: require("../assets/img/sq.png"),
      user: {},
      name:'',
      operatorShow: false,
      backRoutes: ['/area-detail', '/job-log']
    };
  },
  computed: {
    showBack() {
      return this.backRoutes.includes(this.$route.path)
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
   
    this.name=localStorage.getItem("username")
    if (localStorage.getItem("roles") == "operator") {
      this.operatorShow = true;
    
    } else {
      this.operatorShow = false;
    }
    
  },
  methods: {
    handleBack() {
      if (this.$route.path === '/area-detail') {
        this.$root.Bus.$emit('area-detail-back')
      } else {
        this.$router.back()
      }
    },
    changePwd(){
      console.log(111111111111)
      this.editFormVisible02 = true
    },
    changePhone(){
      this.phoneDialogVisible = true
    },
    getVerifyCode(){
      // TODO: 调用获取验证码 API
      this.$message.info('验证码已发送')
    },
    handleUpdatePhone(){
      if (!this.phoneForm.phone) {
        this.$message.warning('请输入手机号')
        return
      }
      if (!this.phoneForm.code) {
        this.$message.warning('请输入验证码')
        return
      }
      // TODO: 调用修改手机号 API
      this.$message.success('修改成功')
      this.phoneDialogVisible = false
    },
    bigScreen(){
      this.$router.push({ path: "/map" });
    },
    editPassword(){
      editPasswordCD(this.addFormInline).then((res) => {
        console.log(res)
        if (res.code == 0) {
          
          this.editFormVisible02 = false;
          this.$store.dispatch('LogOut').then(() => {
          
            this.$router.push({ path: "/login" });
           
          })
          this.$message({
            type: "success",
            message: "密码更改成功，重新登录!",
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 退出登录

    exit() {
      this.$confirm("退出登录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store.dispatch('LogOut').then(() => {
            console.log('退出成功')
            // location.href = getPath('/index');
            this.$router.push({ path: "/login" });
            this.$message({
              type: "success",
              message: "已退出登录!",
            });
          })
          // setTimeout(() => {
          //   this.$store.commit("logout", "false");
          //   this.$router.push({ path: "/login" });
          //   this.$message({
          //     type: "success",
          //     message: "已退出登录!",
          //   });
          // }, 1000);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 切换显示
    toggle1(showtype) {
      this.collapsed = !showtype;
      this.$root.Bus.$emit("toggle", this.collapsed);
    },
    handleCommand(command) {
      if (command === "3") {
        this.exit()
      } else if (command === "2") {
        this.changePwd()
      } else if (command === "4") {
        this.changePhone()
      }
    },
  },
};
</script>
<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
}
.submenu {
  float: right;
}
.buttonimg {
  height: 50px;
  background-color: transparent;
  border: none;
}
.showimg {
  width: 26px;
  height: 26px;
  position: absolute;
  top: 17px;
  left: 17px;
}
.showimg:active {
  border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/TopNav.vue